import { Cloud, Droplet, FrownIcon } from 'lucide-react';

interface CryAnimationProps {
  onClick?: () => void;
}

const CryAnimation: React.FC<CryAnimationProps> = ({ onClick }) => {
  return (
    <div
      className="flex justify-center mb-8 cursor-pointer transition-transform hover:scale-105"
      onClick={onClick}
      role="button"
      title="คลิกเพื่อเลื่อนไปยังตารางแม่พิมพ์"
    >
      <div className="relative">
        {/* Larger animated teardrops */}
        <div className="absolute -left-6 top-10">
          <div className="relative">
            <Droplet
              size={24}
              className="text-blue-300 animate-bounce"
              style={{ animationDelay: '0.3s' }}
            />
            <div className="absolute top-0 left-0 w-full h-full">
              <Droplet size={24} className="text-blue-200 animate-ping" />
            </div>
          </div>
        </div>
        <div className="absolute -right-6 top-10">
          <div className="relative">
            <Droplet size={24} className="text-blue-300 animate-bounce" />
            <div className="absolute top-0 left-0 w-full h-full">
              <Droplet size={24} className="text-blue-200 animate-ping" />
            </div>
          </div>
        </div>

        {/* Main sad face with gradient background */}
        <div className="bg-gradient-to-b from-gray-50 to-gray-100 p-8 rounded-full shadow-inner">
          <FrownIcon size={80} className="text-gray-400" />
        </div>

        {/* Multiple small clouds */}
        <div className="absolute -top-6 -left-8">
          <Cloud size={20} className="text-gray-200" />
        </div>
        <div className="absolute -top-4 -right-6">
          <Cloud size={24} className="text-gray-300" />
        </div>
      </div>
    </div>
  );
};

export default CryAnimation;
